
import { Component, Injectable, Inject } from '@angular/core';
import {MatSnackBar,MAT_SNACK_BAR_DATA} from '@angular/material';

/**
 * @title Snack-bar with a custom component
 */
@Injectable()
export class ToastMessage {
  constructor(public snackBar: MatSnackBar) {}

  openSnackBarSuccess(message) {
    this.snackBar.openFromComponent(ToastSnackbar, {
      duration: 3000,
      panelClass: ['mat-snack-bar-container'],
      data: message
    });
  }
  openSnackBarError(message) {
    this.snackBar.openFromComponent(ToastSnackbar, {
      duration: 5000,
      panelClass: ['mat-snack-error-container'],
      data: message
    });
  }
}


@Component({
  selector: 'toast-snackbar',
  template: require('./toast-snackbar.html')
})
export class ToastSnackbar {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any){
   
  }
}


/**  Copyright 2018 Google Inc. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license */
